import { Box, Stack } from '@mui/material';
import { DateRangeSwitcher } from '@tyro/core';
import type { Dayjs } from 'dayjs';
import type { ReturnTypeFromUseAttendanceCodes } from '../../api/attendance-codes';
import { AttendanceCodeFilter } from '../attendance-code-filter';
import { RollbookViewSwitcher } from './view-switcher';

interface RollbookToolbarProps {
  dateRange: [Dayjs, Dayjs];
  setDateRange: (range: [Dayjs, Dayjs]) => void;
  view: 'icons' | 'codes';
  setView: (view: 'icons' | 'codes') => void;
  codeFilter: ReturnTypeFromUseAttendanceCodes[];
  setCodeFilter: (value: ReturnTypeFromUseAttendanceCodes[]) => void;
  maxWeeks?: number;
}

export function RollbookToolbar({
  dateRange,
  setDateRange,
  view,
  setView,
  codeFilter,
  setCodeFilter,
  maxWeeks = 4,
}: RollbookToolbarProps) {
  return (
    <Stack direction="row" justifyContent="space-between" p={2}>
      <Box flex="1">
        <RollbookViewSwitcher value={view} onChange={setView} />
      </Box>
      <Box flex="1" display="flex" justifyContent="center" alignItems="center">
        <DateRangeSwitcher
          value={dateRange}
          onChange={setDateRange}
          maxDateRange={(firstSelectedDate) =>
            firstSelectedDate.add(maxWeeks, 'weeks')
          }
        />
      </Box>
      <Box flex="1" display="flex" justifyContent="flex-end">
        <AttendanceCodeFilter value={codeFilter} onChange={setCodeFilter} />
      </Box>
    </Stack>
  );
}
